export const noop = () => {
};

// It covers tha cases if value is null and value is undefined
export const isNull = (value: any) => (value == null);

export const  isNotNull = (value: any) => (!isNull(value));
